function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m53.689 63.991a7.4629 7.4629 0 0 1-5.2952-2.2277l-16.398-16.298-16.398 16.31a7.4629 7.4629 0 0 1-8.2508 1.6238 7.4629 7.4629 0 0 1-4.6753-7.007v-43.062a13.33 13.33 0 0 1 13.33-13.33h31.995a13.33 13.33 0 0 1 13.33 13.33v43.062a7.4629 7.4629 0 0 1-4.6633 6.999 7.6429 7.6429 0 0 1-2.9636 0.59191zm-37.686-58.659a7.9988 7.9988 0 0 0-7.9988 7.9988v43.062a2.2477 2.2477 0 0 0 3.8314 1.5998l18.297-18.181a2.6676 2.6676 0 0 1 3.7594 0l18.273 18.181a2.2477 2.2477 0 0 0 3.8314-1.5998v-43.062a7.9988 7.9988 0 0 0-7.9988-7.9988z",
    fill: "currentColor",
    style: {
      strokeWidth: 3.9994
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.6ce260af.svg";
export { ForwardRef as ReactComponent };